export const home = "/";
export const Signin = "/signin";
export const myaccount = "my-account";
export const personaldetail = "personal-account";
export const orderhistory = "order-history";
export const myaddress = "my-address";
export const mywishlist = "/my-whishlist";
export const mynotification = "my-notification";
export const mysettings = "setting";
export const productlisting = "/productlisting";
export const productdetail = "productdetail";
export const mycart = "/mycart";
export const checkout = "/checkout";
export const trackorder = "/trackorder";
export const termsConditions = "terms-and-conditions";
export const contactus = "contact-us";
export const offerhome = "offer-home";
export const purplestylelab = "purplestylelab";
export const perniapopupshop = "perniapopupshop";
export const studiolocatore = "studiolocatore";
export const magazine = "magazine";
export const shipingInformation = "shipingInformation";
export const returnsAndExchange = "returns-and-exchange";
export const faq = "faq";
export const privacypolicy = "privacy-policy";
export const bestSeller = "best-seller";
export const celebritycloset = "celebrity-closet";
export const exclusive = "exclusive";
export const offers = "offers";
export const giftCards = "giftCards";
export const personalStyling = "personalStyling";
export const occasions = "occasions";

